import type { FloatBlockAbstract } from '@lighthouse/core'
import type { FlowLayoutNode } from '@lighthouse/shared'
import { FloatBoxBlockProvider, useFloatBoxBlockContext } from '@lighthouse/shared'
import React, { memo } from 'react'

import { ContainerLayout } from '../../components/ContainerLayout'
import { useEffectiveAnchorId } from '../../context'
import { useScrollToAnchorWhenHashMatch } from '../../hooks/useScrollToAnchorWhenHashMatch'

interface FloatBlockProps extends React.ComponentPropsWithoutRef<'div'> {
    disabled?: boolean
    shown?: boolean
    node: FlowLayoutNode
    blockData: FloatBlockAbstract
    children?: React.ReactNode
}

const FloatBlock = React.forwardRef<HTMLDivElement, FloatBlockProps>(({ blockData, disabled, children, ...rest }, ref) => {
    const { id, rootId } = useFloatBoxBlockContext()
    const anchor = blockData.config?.anchor
    const { anchorId } = anchor || {}
    const effectiveAnchorId = useEffectiveAnchorId(anchorId)
    useScrollToAnchorWhenHashMatch(effectiveAnchorId, anchor)
    return (
        <FloatBoxBlockProvider id={blockData.id} rootId={rootId || id}>
            <ContainerLayout ref={ref} disabled={disabled} id={effectiveAnchorId} {...rest}>
                {children}
            </ContainerLayout>
        </FloatBoxBlockProvider>
    )
})

export default memo(FloatBlock)
